import { Spinner } from "phosphor-react"
import { useEffect, useRef } from "react"
import { EVENT_IDS, EVENTS } from "~/common/analytics"
import { trackEvent } from "~/common/analytics"

import { Link } from "~/ui/link"
import { PhoneNumberInput } from "~/ui/phone-number/phone-number-input"
import { useDownloadAppPhoneSubmission } from "~/hooks/use-phone-submission"

const TRACKING_DATA = {
  unique_id: EVENT_IDS.GET_APP_CLICKED,
}

export function GetTheAppDesktop() {
  const { phoneValue, setPhoneValue, submitPhoneNumber, mutationPending } =
    useDownloadAppPhoneSubmission()

  const hasTrackedPhoneRef = useRef(false)

  useEffect(() => {
    const digits = phoneValue.number.replace(/\D/g, "")
    if (digits.length >= 10 && !hasTrackedPhoneRef.current) {
      hasTrackedPhoneRef.current = true
      trackEvent(EVENTS.PHONE_NUMBER_ENTERED, {
        phone_number_last_4: digits.slice(-4),
      })
    }
    if (digits.length < 10) {
      hasTrackedPhoneRef.current = false
    }
  }, [phoneValue.number])

  const handleGetAppClick = async () => {
    await submitPhoneNumber({
      successMessage: "Texting you a link to download the app.",
      trackingData: TRACKING_DATA,
    })
  }

  return (
    <div className="hidden h-20 w-full flex-row pt-8 md:flex">
      <div className="flex flex-row">
        <PhoneNumberInput
          value={phoneValue}
          onChange={setPhoneValue}
          onSubmit={handleGetAppClick}
          className="pr-4"
          inputClassName="rounded-xs min-w-60"
        />
        <Link
          to="#"
          onClick={(e) => {
            e.preventDefault()
            handleGetAppClick()
          }}
        >
          <button className="flex h-12 w-full min-w-[180px] items-center justify-center rounded-full border border-base-black bg-support-yellow py-3">
            <div className="font-md-nichrome text-18 font-medium leading-8 text-base-black">
              {mutationPending ? <Spinner className="animate-spin" /> : "GET THE APP"}
            </div>
          </button>
        </Link>
      </div>
    </div>
  )
}
